import {ServerRepoId, VABLoginQuery} from '../../autogenerated/ZoomBridge';
import Authenticator from '../../protocol/Authenticator';

export default class VabLoginExecutor {
  constructor(username, cookie, password) {
    this.username = username;
    this.cookie = cookie;
    this.password = password;
  }

  run() {
    return new Promise((onSuccess, onFailure) => {
      Authenticator.AUTH_DATA.username = this.username;
      Authenticator.AUTH_DATA.password = this.password;
      Authenticator.AUTH_DATA.cookie = this.cookie;

      const vabLoginQuery = new VABLoginQuery();
      vabLoginQuery.message = "Login";
      vabLoginQuery.run().then(
        (resp) => {
          onSuccess(resp);
        },
        (failedResp) => {
          onFailure(failedResp);
        }
      );
    });
  }
}